<compartido-formulario
  *ngIf="direccion"
  [configuracion]="configFormulario"
  (valores)="valorFormulario = $event"
  (valido)="validezFormulario = $event"
></compartido-formulario>

<ng-container
  *ngIf="direccion && (edicion === 'activable' || edicion === 'activada')"
>
  <div
    class="botones"
    *permisos="{ cliente: [Permiso.EDITAR] }"
    [class.dos-botones]="editar()"
  >
    <button
      mat-flat-button
      color="primary"
      class="boton-editar"
      *ngIf="!editar() && edicion === 'activable'"
      (click)="activarEdicion()"
    >
      <mat-icon>edit</mat-icon>
      Editar
    </button>

    <button
      mat-button
      color="warn"
      class="boton-cancelar"
      *ngIf="editar() && edicion === 'activable'"
      (click)="desactivarEdicion()"
    >
      <mat-icon>cancel</mat-icon>
      Cancelar
    </button>

    <button
      mat-flat-button
      color="primary"
      class="boton-guardar"
      *ngIf="editar() || edicion === 'activada'"
      (click)="guardarCambios()"
    >
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </div>
</ng-container>

<div class="cargando" *ngIf="cargando()">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<div class="sin-datos" *ngIf="!cargando() && direccion === undefined">
  <mat-icon>info</mat-icon>
  <span>No se encontraron datos de la dirección.</span>
</div>
